import { useState, useEffect } from "react";
import empty_state from "../../../../../Assets/Images/empty_temp.png";
import css from "./AddTemplate.module.css";

import Svg from "../../../../../Components/Svg/Svg";
import SvgOptions from "../../../../../Components/Svg/SvgOptions";
import Modal from "../../../../../Components/Modal/Modal";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SelectQuestionsModal = ({
	isOpen,
	onClose,
	onSelect,
	selectedQuestions,
	availableQuestions,
}) => {
	const navigate = useNavigate();
	const [tempSelected, setTempSelected] = useState([]);

	// Sync selected values when modal opens
	useEffect(() => {
		setTempSelected(selectedQuestions.map((q) => q.id));
	}, [isOpen]);

	const hasQuestions = availableQuestions.length > 0;

	const toggle = (id) => {
		setTempSelected((prev) =>
			prev.includes(id) ? prev.filter((q) => q !== id) : [...prev, id]
		);
	};

	const handleContinue = () => {
		const selected = availableQuestions.filter((q) =>
			tempSelected.includes(q.id)
		);
		onSelect(selected);
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Select Risk Assessment Questions"
			size="md"
			className={css.ModalForm}
			centered
		>
			{!hasQuestions ? (
				<>
					<div className={css.EmptyState}>
						<img src={empty_state} alt="No Questions" />
						<p className={css.EmptyText}>No Questions Yet</p>
					</div>

					<button
						onClick={() => navigate("../CreateQuestion")}
						className={css.PrimaryBtn}
					>
						<Plus size={16} />
						Add New Question
					</button>
				</>
			) : (
				<>
					<div>
						<div className={css.ListHeader}>
							<h4>Question</h4>
							<h4>Actions</h4>
						</div>

						{availableQuestions.map((q) => (
							<div key={q.id} className={css.QuestionItem}>
								<div className={css.QuestionContent}>
									<Svg>{SvgOptions.Moving}</Svg>
									<label htmlFor={q.id}>{q.questionText}</label>
								</div>

								<input
									id={q.id}
									type="checkbox"
									checked={tempSelected.includes(q.id)}
									onChange={() => toggle(q.id)}
									className={css.Checkbox}
								/>
							</div>
						))}
					</div>

					<div className={`${css.ModalFooter} ${css.BtnGroup}`}>
						<button onClick={onClose} className={css.CancelBtn}>
							Cancel
						</button>
						<button onClick={handleContinue} className={css.PrimaryBtn}>
							Continue
						</button>
					</div>
				</>
			)}
		</Modal>
	);
};

export default SelectQuestionsModal;
